var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"click":function($event){return _vm.resetTimer()},"touchstart":function($event){return _vm.resetTimer()}}},[_c('my-header'),_c('router-view'),_c('section',{staticClass:"copyright"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }